<script>
    import TwinklingStar from "./Elements/TwinklingStar.svelte";
    import {onMount} from "svelte";
    import {labels, mainTimeline} from "../timelines/main-timeline";
    import gsap from "gsap";

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const startPosition = {x: 250, y: 250};
    const endMin = 150;
    const endMax = 50;
    const stars = Array.from(new Array(85));

    const {circleStart, circleEnd} = labels;


    function drawPoint(min, max, cx, cy) {
        const angle = Math.random() * 360;
        const distance = min + max * Math.random();

        const x = cx + distance * Math.cos(- angle * Math.PI / 180);
        const y = cy + distance * Math.sin(- angle * Math.PI / 180);

       return {x, y};
    }

    function randoPosition() {
        const {x, y} = drawPoint(endMin, endMax, startPosition.x, startPosition.y);
        return `translate(${x} ${y})`;
    }

    onMount(() => {
        inTimeline
            .from('.star2', {
                x: startPosition.x / 2,
                y: startPosition.y / 2,
                opacity: 0,
                scale: 0,
                duration: 1,
                stagger: 0.005,
                transformOrigin: '50% 50%'
            });

        outTimeline.to('.star2', {
            opacity: 0,
            duration: 1,
        })

        mainTimeline.add(inTimeline, circleStart);
        mainTimeline.add(outTimeline, circleEnd);
    });

</script>

<svg width="500px" viewBox="0 0 500 500" x="720" y="190">
    <g class="star-container-outer">
        <g class="all-stars2" >
            <g class="star-container-inner">
            {#each stars as star, i}
                <g transform={randoPosition()} class="star2">
                    <TwinklingStar />
                </g>
            {/each}
            </g>
        </g>
    </g>
</svg>

<style>

    .all-stars2 {
        -webkit-animation-name: rotate;
        -webkit-animation-duration: 14s;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: linear;
        -moz-animation-name: rotate;
        -moz-animation-duration: 14s;
        -moz-animation-iteration-count: infinite;
        -moz-animation-timing-function: linear;
        animation-name: rotate;
        animation-duration: 14s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;

    }
    @-webkit-keyframes rotate {
        from {-webkit-transform: rotate(0deg);}
        to {-webkit-transform: rotate(360deg);}
    }

    @-moz-keyframes rotate {
        from {-moz-transform: rotate(0deg);}
        to {-moz-transform: rotate(360deg);}
    }

    @keyframes rotate {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }


    .star-container-outer {
        transform: translate(250px, 250px);
    }
    .star-container-inner {
        transform: translate(-250px, -250px);
    }
</style>
